import React from "react";
import { createPortal } from "react-dom";
import Modal from "../../../../Components/Modal";

const TommyArtikelenModal = ({ 
  isOpen, 
  onClose, 
  artikelen 
}) => {
  return createPortal(
    <Modal 
      visible={isOpen} 
      onClose={onClose}
      width="95%"
    >
      <div className="modal-header border-bottom pb-3 mb-3">
        <h4 className="modal-title">
          <i className="fas fa-list me-2"></i>
          Tommy Artikelen ({artikelen.length} gevonden)
        </h4>
      </div>
          <div className="modal-body">
            {artikelen.length === 0 ? (
              <div className="text-center py-4">
                <i className="fas fa-box-open fa-3x text-muted mb-3"></i>
                <h5 className="text-muted">Geen artikelen gevonden</h5>
                <p className="text-muted">Er zijn geen artikelen gevonden in het Tommy systeem.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead className="table-dark">
                    <tr>
                      <th>ID</th>
                      <th>Naam</th>
                      <th>Groep</th>
                      <th>Verplicht</th>
                      <th>Actief</th>
                      <th>Max. Aantal</th>
                      <th>Order</th>
                      <th>Beschrijving</th>
                    </tr>
                  </thead>
                  <tbody>
                    {artikelen.map((artikel) => (
                      <tr key={artikel.id}>
                        <td>
                          <code>{artikel.id}</code>
                        </td>
                        <td>
                          <strong>{artikel.name || '-'}</strong>
                        </td>
                        <td>
                          {artikel.groupName ? (
                            <div>
                              <span className="badge bg-secondary">{artikel.groupName}</span>
                              {artikel.groupOrder !== undefined && (
                                <small className="text-muted ms-2">#{artikel.groupOrder}</small>
                              )}
                            </div>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td>
                          <span className={`badge ${artikel.mandatory ? 'bg-warning' : 'bg-light text-dark'}`}>
                            {artikel.mandatory ? 'Ja' : 'Nee'}
                          </span>
                        </td>
                        <td>
                          <span className={`badge ${artikel.active ? 'bg-success' : 'bg-danger'}`}>
                            {artikel.active ? 'Actief' : 'Inactief'}
                          </span>
                        </td>
                        <td>
                          {artikel.maximumAmount > 0 ? (
                            <span className="badge bg-dark">{artikel.maximumAmount}</span>
                          ) : (
                            <span className="text-muted">Onbeperkt</span>
                          )}
                        </td>
                        <td>
                          <code className="small">{artikel.order || '0'}</code>
                        </td>
                        <td>
                          <span 
                            className="text-muted" 
                            style={{ 
                              maxWidth: '300px', 
                              display: 'block', 
                              overflow: 'hidden', 
                              textOverflow: 'ellipsis', 
                              whiteSpace: 'nowrap' 
                            }} 
                            title={artikel.description}
                          >
                            {artikel.description || '-'}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
      <div className="modal-footer border-top pt-3 mt-3">
        <button 
          type="button" 
          className="btn btn-secondary"
          onClick={onClose}
        >
          Sluiten
        </button>
      </div>
    </Modal>,
    document.body
  );
};

export default TommyArtikelenModal;